var path = '/app/components/ui/speed-dial/speed-dial.html';
var html = "<div class=flex-column> <div class=album-button ng-click=$ctrl.toStagesMenu()></div> <div class=parts-button ng-click=$ctrl.toPuzzle()></div> <div class=help-button ng-click=$ctrl.toHelp()></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/speed-dial/speed-dial.html
// module id = 188
// module chunks = 0